/**
 * Login/Index Controller
 *
 * 
 */

// the constructor for this object
function LoginIndexController() { }

// the object
LoginIndexController.prototype = {
    constructor: LoginIndexController,
    
    // the reason a user was redirected to this page
    redirectReason: false,
    
    // initialize the controller
    init: function() 
    {
        // register the route variables used by this controller
        this._registerRouteVariables();
        
        PortalHelper.debugMessage('Login Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // show the user why they were redirected
        this._displayRedirectReason();
        
        // get the notification outages
        this._getNotificationOutages();
        
        // register the events used by this controller
        this._registerEvents();
        
        // turn on the submit button
        PortalHelper.enableButton('#login-button');
        
        PortalHelper.debugMessage('Login Controller Ran');
    },
    
    // get the route variables and include them in the controller
    _registerRouteVariables: function() 
    {
        var segments = PortalMain.getRouteSegments();
        
        this.redirectReason = segments[0];
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // confirm the user and password
        $('#login-form').on('submit', function(e) {
            e.preventDefault();
            
            var email = $('#login-form #email').val();
            var password = $('#login-form #password').val();
            
            // disable login button while making request
            PortalHelper.disableButton('#login-button');
            PortalMain.LoginIndexController.confirmUserPassword(email, password);
        });
        
        // get the token
        $('#passcode-form').on('submit', function(e) {
            e.preventDefault();
            
            PortalHelper.disableButton('#passcode-button');
            PortalMain.LoginIndexController.getToken();
        });
        
    },
    
    // confirm the user password
    confirmUserPassword: function(email, password) 
    {
        PortalHelper.loadingOverlay('#login-form', true);
        
        PortalHelper.disableButton('#login-button');
    
        var confirmUserPasswordRequest = new PortalRequest;
        confirmUserPasswordRequest.errorElement = '#login-errors';
        confirmUserPasswordRequest.makeRequest(
            '/auth/confirm-user-password',
            {
                email: email,
                password: password
            },
            function(data, code, message) {
                
                if (!data.two_factor_enabled) {
                    PortalMain.LoginIndexController.getToken();
                } else {
                    PortalMain.LoginIndexController._showPasscodeForm();
                }
            },
            function() {
                PortalHelper.enableButton('#login-button');
                
                PortalHelper.loadingOverlay('#login-form', false);
                PortalHelper.enableButton('#login-button');
            }
        );
    },
    
    // get the token
    getToken: function() 
    {
    
        PortalHelper.loadingOverlay('#passcode-form', true);
        
        var email = $('#login-form #email').val();
        var password = $('#login-form #password').val();
        var passcode = $('#passcode-form #passcode').val();
        
        PortalHelper.disableButton('#passcode-button');
    
        var tokenRequest = new PortalRequest;
        tokenRequest.storeToken = true;
        tokenRequest.errorElement = '#login-errors';
        tokenRequest.makeRequest(
            '/auth/get-token',
            {
                email: email,
                password: password,
                passcode: passcode
            },
            function(data, code, message) {
                PortalMain.LoginIndexController.showSuccesfulLogin();
                PortalMain.LoginIndexController.loginComplete();
            },
            function() {
                PortalHelper.enableButton('#passcode-button');
                
                PortalHelper.loadingOverlay('#login-form', false);
                PortalHelper.loadingOverlay('#passcode-form', false);
                PortalHelper.enableButton('#login-button');
                PortalHelper.enableButton('#passcode-button');
            }
        );
    },
    
    // show the user that they have logged in successfully
    showSuccesfulLogin: function()
    {
        PortalHelper.loadingOverlay('#login-form', false);
        PortalHelper.loadingOverlay('#passcode-form', false);
        $('#login-success').removeClass('hidden');
    },
    
    // setup the starting data for the user
    loginComplete: function()
    {
        PortalMain.PortalLogin.callback = function() {
            PortalHelper.sendToDashboard();
        }
        PortalMain.PortalLogin.updateLoginData();
    },
    
    // show the user why the were redirected here
    _displayRedirectReason: function()
    {
        var reason = PortalMain.LoginIndexController.redirectReason;
        
        if (reason == 'session') {
            $('#login-form .form-errors').html('Your previous session is no longer valid. Please log in again.');
            $('#login-form .form-errors').removeClass('hidden');
        }
        
        if (reason == 'user-data') {
            $('#login-form .form-errors').html('There was an issue getting your user data. Please log in again.');
            $('#login-form .form-errors').removeClass('hidden');
        }
        
        // redirected from the old portal
        if (reason == 'portal-redirect') {
            $('.welcome-message').removeClass('hidden');
        }
    },
    
    // get the notification outages
    _getNotificationOutages: function()
    {
        var notificationOutagesRequest = new PortalRequest;
        notificationOutagesRequest.makeRequest(
            '/notifications/get-outages',
            {},
            function(data) {
                PortalMain.LoginIndexController._populateNotificationOutages(data);
            }
        );
    },
    
    // fill in the notification outages
    _populateNotificationOutages: function(data)
    {
        // clear the old tickets
        $('#outages .outage:not(.clone-source)').remove();
        
        for (var i in data) {
            var outage = data[i];
            
            var newEntry = $('#outages .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the mrc charges
            var message = PortalHelper.breaksToBr(outage.message);
            $('.box-content', newEntry).html(message);
            
            // add to to the table
            $('#outages').append(newEntry);
            
        }
    },
    
    // show the two factor section
    _showPasscodeForm: function()
    {
        $('#login-form').addClass('hidden');
        $('#passcode-form').removeClass('hidden');
        
        PortalHelper.disableButton('#login-button');
        PortalHelper.enableButton('#passcode-button');
    }
    
}